export const getEntityFragment = () => `entity {
    ${getEntityFragmentContents()}
}`

export const getEntityFragmentContents = () => `name
    nameHtml
    nameClean
    alias
    author
    description
    descriptionHtml
    descriptionClean
    id
    parentId
    entityType
    tags
    example {
      label
      language
      code
      codeHighlighted
    }
    avatar {
      url
    }
    homepage {
      url
    }
    amazon {
      url
    }
    wikipedia {
      url
    }
    steam {
      url
    }
    youtube {
      url
    }
    twitter {
      url
    }
    bluesky {
      url
    }
    threads {
      url
    }
    twitch {
      url
    }
    rss {
      url
    }
    blog {
        url
    }
    mastodon {
        url
    }
    github {
        url
    }
    npm {
        url
    }
    mdn {
        url
    }
    caniuse {
        url
    }
    resources {
        url
        title
    }
    webFeature {
        id
        description_html
        group
        name
        spec
        url
        status {
            baseline
            baseline_low_date
            support {
            chrome
            chrome_android
            edge
            firefox
            firefox_android
            safari
            safari_ios
            }
        }
    }`
